import React, { useState, useEffect } from 'react'
import './css/completionInd.css'
import { FaToggleOff, FaToggleOn } from "react-icons/fa";

const CompletionInd = (props) => {
    const [style, setStyle] = useState({})
    const [completionPct, setCompletionPct] = useState(props.completionPct)

    useEffect(() => {
        setCompletionPct(props.completionPct)
    }, [props])

    setTimeout(() => {
        const newStyle = {
            opacity: 1,
            width: `${completionPct.pct}%`
        }
        setStyle(newStyle);
    }, 200);

    return (
        <div>
            <div className="col-sm-12 padding-remove" >
                <h1 style={{ fontSize: 20 }}>Completion</h1>
            </div>
            <div className="col-sm-12 padding-remove" >
                <div className="col-sm-4 padding-remove"  >
                    <div className="progress" style={{ display: 'inline-table' }}>
                        <div className="progress-done" style={style}>
                        </div>
                    </div>
                    <div style={{ display: 'inline-table', marginLeft: '15px' }}>
                        {completionPct.total ?
                            <span style={{ fontSize: 20 }}>{completionPct.completed + '/' + completionPct.total}</span>
                            : null
                        }
                    </div>
                </div>
                <div className="col-sm-5 padding-remove">
                    <div className="col-sm-6 padding-remove" title="Turn it on to replace all substitutes">
                        <div className='col-sm-9 padding-remove' style={{ textAlign: 'right', marginTop: "5px", paddingRight: "10px" }}>
                            <label className="control-label" >{"Replace Existing: "}</label>
                        </div>
                        <div onClick={() => props.setReplaceExisting((prev) => !prev)} className='col-sm-2 padding-remove' style={{ textAlign: 'center' }}>
                            {
                                props.replaceExisting ?
                                    <FaToggleOn
                                        color="orange"
                                        style={{ fontSize: "30px", cursor: "pointer" }}
                                    />
                                    :
                                    <FaToggleOff
                                        color="gray"
                                        style={{ fontSize: "30px", cursor: "pointer" }}
                                    />
                            }
                        </div>
                    </div>

                    <div className="col-sm-6 padding-remove" >
                        <button className="button-disruption" style={{ width: "90%", marginTop: 3 }} onClick={props.autoSubstitution}> Auto Substitution</button>
                    </div>
                </div>
                <div className="col-sm-3 padding-remove text-right">
                    <div className="col-sm-6" style={{ height: 20 }}></div>
                    <div className="col-sm-2 padding-remove text-right" >
                        <div style={{ width: '90%' }}>
                            <img src={require("common/images/pdf.png")} style={{ cursor: 'pointer', height: 30 }} onClick={(e) => props.setFlgView(true)} alt="Subs. Duty PDF" title="Subs. Duty PDF" />
                        </div>
                    </div>
                    <div className="col-sm-2 padding-remove text-right" >
                        <div style={{ width: '90%' }}>
                            <img src={require("common/images/excel.png")} style={{ cursor: 'pointer', height: 30 }} onClick={(e) => props.downloadExcel()} alt="Subs. Duty Excel" title="Subs. Duty Excel" />
                        </div>
                    </div>
                    <div className="col-sm-2 padding-remove text-right" >
                        <div style={{ width: '90%' }}>
                            <span className="glyphicon glyphicon-remove-circle" style={{ fontSize: 27, cursor: 'pointer', color: 'gray' }} onClick={props.handleRemoveSubstituion} title="Remove all substitutions"></span>
                        </div>
                    </div>
                {/* </div> */}

            </div>
        </div>
        </div >
    )
}
export default CompletionInd;